export type Dimension = {
  dimension_name: string;
  display_name: string;
  dimension_type?: string;
};

export type CommonItem = {
  name: string;
  value: string;
};

export type FieldViewModel = {
  name: string;
  operators: CommonItem[];
  value: string;
  values: CommonItem[];
  urls: Record<string, unknown>;
  autocompletion_only: boolean;
};

export type DimensionViewModel = {
  fields: FieldViewModel[];
  name: string;
};

export const commonOperators = [
  {
    name: 'contains',
    value: 'contains',
  },
  {
    name: 'not contains',
    value: 'not contains',
  },
  {
    name: 'equals',
    value: 'eq',
  },
  {
    name: 'not equals',
    value: 'not eq',
  },
];
